/**
 * /livret-125 — Livret interactif Formation 125 (7 h).
 * Réservé aux comptes élève / enseignant / admin (via ProtectedRoute).
 */
import React from 'react';
import LivretInteractif from '../../components/livrets/LivretInteractif';
import { LIVRET_125 } from '../../data/livret125Data';

export default function Livret125() {
  return <LivretInteractif data={LIVRET_125} testid="livret-125" />;
}
